module.exports = __webpack_public_path__ + "img/002.7ff304e3.png";